<template>
  <div class="lower-fuzzy__container">
    <template v-if="configTest.length">
      <div
        v-for="(item, index) in configTest"
        :key="item.RelatedThreshold"
        class="lower-fuzzy__container--item"
      >
        <b-form-group label="Source Fields">
          <select
            :id="`source-fields-${index}`"
            v-model="item.SourceFieldGuid"
            class="mr-sm-2 custom-select"
          >
            <option
              v-for="option in getRelatedFields"
              :id="$options.filters.displayName(option.displayName)"
              :value="option.fieldGuid"
            >
              {{ option.displayName }}
            </option>
          </select>
        </b-form-group>

        <b-form-group label="Related Fields">
          <select
            :id="`related-fields-${index}`"
            ref="type"
            v-model="item.RelatedFieldGuid"
            class="mr-sm-2 custom-select"
          >
            <option
              v-for="option in getRelatedColumnOptions(item.SourceFieldGuid)"
              :id="$options.filters.displayName(option.displayName)"
              :value="option.fieldGuid"
            >
              {{ option.displayName }}
            </option>
          </select>
        </b-form-group>
        <validation-provider
          v-slot="{errors, dirty, valid}"
          rules="numeric|required|min_value:1|max_value:100"
        >
          <b-form-group label="Match Threshold">
            <b-input-group append="%">
              <b-form-input
                :id="`match-threshold-${index}`"
                v-model="item.MatchThreshold"
                :state="!dirty ? null : valid ? null : false"
              />
            </b-input-group>
            <input-error-message :error="errors" />
          </b-form-group>
        </validation-provider>
        <b-button
          :id="`delete-btn-${index}`"
          class="trash__button"
          variant="outlined"
          @click="removeElementFromList(item.key)"
        >
          <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
      </div>
    </template>
    <no-content :show="!configTest.length" />

    <b-button @click="onFuzzyMatchingRelationAdd">
      Add Field Pairs
    </b-button>
  </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import NoContent from '@/core/components/NoContent.vue';
import InputErrorMessage from '@/modules/DataManagement/components/InputErrorMessage.vue';
import {createNamespacedHelpers} from 'vuex';

const {
  mapState: dataManagementMapState,
  mapActions: dataManagementMapActions,
} = createNamespacedHelpers('dataManagement');
export default {
  name: 'LowerFuzzyMatchingList',
  components: {InputErrorMessage, NoContent},
  props: [
    'table',
    'field',
    'getRelatedColumnOptions',
  ],
  data() {
    return {
      fuzzyMatchingRelations: [],
    };
  },
  computed: {
    ...dataManagementMapState({
      configTest: state => state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig.FieldConfigs,
    }),
    getRelatedFields() {
      return this.table.fields.filter(tf => {
        return tf.dataTypeName !== 'lookup' && ('calculation' in tf) && tf.fieldGuid !== this.field.fieldGuid;
      });
    },
  },
  methods: {
    ...dataManagementMapActions([
      'updateFuzzyList',
      'removeElementFromFuzzyList',
    ]),
    onFuzzyMatchingRelationAdd() {
      const item = {
        key: uuidv4(),
        SourceFieldGuid: '',
        RelatedFieldGuid: '',
        MatchThreshold: 80 ,
      };
      this.updateFuzzyList(item);
    },
    removeElementFromList(key) {
      this.removeElementFromFuzzyList(key);
    },
  },
};
</script>


<style scoped lang="scss">
.trash__button {
  height: fit-content;
  margin-top: 10px;
  color:  red;
  transition: 0.4s;

  &:hover {
    transform: scale(1.1);
  }
}
.lower-fuzzy__container {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.lower-fuzzy__container--item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  align-items: center;
  gap: 5px;
}
</style>